import React, { useMemo } from 'react';
import { SearchSelect } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/components/SearchSelect';
import { FormValue } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/types';
import { useAppSelector } from 'src/utils/Hooks';
import { usePresentationFormContext } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/PresentationFormContext';

interface SubCategorySelectProps {
  selectedCategoryIds: FormValue[];
  selectionOrder: 'category' | 'subcategory' | null;
  onSelectionChange: (newValue: FormValue[]) => void;
}

export const SubCategorySelect = ({ selectedCategoryIds, selectionOrder, onSelectionChange }: SubCategorySelectProps) => {
  const {
    selections: { control }
  } = usePresentationFormContext();
  const subCategories = useAppSelector((state) => state.subCategories);
  const subcategoriesByCategory = useMemo(() => {
    if (selectionOrder === 'category' && selectedCategoryIds.length > 0) {
      return subCategories.filter((sc) => {
        return selectedCategoryIds.some((selectedCat) => selectedCat.id === sc.parentCategoryId.toString());
      });
    }
    return subCategories;
  }, [subCategories, selectedCategoryIds, selectionOrder]);

  const selectOptions = subcategoriesByCategory.map((subcategory) => ({
    id: subcategory.id,
    value: subcategory.id.toString(),
    displayName: subcategory.displayName
  }));

  return (
    <SearchSelect
      name="subcategoryIds"
      title="Subcategory Inclusions"
      placeholder="Search or select subcategories you would like to add to your presentation"
      selectOptions={selectOptions}
      isMulti={true}
      control={control}
      onSelectionChange={onSelectionChange}
    />
  );
};
